module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-fr.800f75bf5809d9c98578.svg";